export const STRIPE_INDIVIDUAL_PLAN_PRICE = 15;

export const UserCohortMay = 'MAY';
export const UserCohortNov = 'NOV';
